import {Component, OnInit} from '@angular/core';
import {PermissionsService} from "../../../services/permissions/permissions.service";
import { getPermissionsConfig } from './permission-help.config';

@Component({
  selector: 'app-permission-help',
  templateUrl: './permission-help.component.pug',
  styleUrls: ['./permission-help.component.scss'],
  standalone: false
})
export class PermissionHelpComponent implements OnInit {
  selectedTab = 'reference';
  ENT_11525_UNLOCK_XREF_ME = false;
  permissions: any;

  constructor(private permissionService: PermissionsService) {}

  ngOnInit(){
      this.ENT_11525_UNLOCK_XREF_ME = this.permissionService.isFeatureActivated('ent-11525-unlock-xref-me');
      this.permissions = getPermissionsConfig(this.ENT_11525_UNLOCK_XREF_ME);
  }

  changeTab(tab: string): void {
    this.selectedTab = tab;
    const element = document.getElementById(tab);
    if (element) {
      const offset = -32; // Adjust this value to your needs
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset + offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }
  isDirty() { return false; }
}
